import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@pattern-library/buttons';
import withLiveValidation from '@pattern-library/with-live-validation';
import TextInput from '@pattern-library/text-input';
import { useFormValidation, formValidationMethods } from '@pattern-library/base';

const propTypes = {
    formAction: PropTypes.string.isRequired,
    antiForgeryToken: PropTypes.string.isRequired,
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    usernameInputProps: PropTypes.objectOf(PropTypes.string).isRequired
};

const UsernameLiveValidation = withLiveValidation(TextInput);

function UpdateUsernameForm(props) {
    const { formAction, antiForgeryToken, buttonProps, usernameInputProps } = props;
    const usernameInputName = usernameInputProps.name;

    const schema = {
        [usernameInputName]: [
            {
                validationMethod: value => formValidationMethods.isLengthInRange(value, 5, 50),
                errorMessage: 'Username must be between 5 and 50 characters',
                validationLabel: 'Between 5 and 50 characters in length',
                ariaLabel: 'Must be between 5 and 50 characters in length'
            },
            {
                validationMethod: formValidationMethods.containsLetter,
                errorMessage: 'Username must contain at least one letter',
                validationLabel: 'Contains at least one letter',
                ariaLabel: 'Must contain at least one letter'
            },
            {
                validationMethod: formValidationMethods.startsWithLetterOrNumber,
                errorMessage: 'Username must start with a letter or number',
                validationLabel: 'Starts with a letter or number',
                ariaLabel: 'Must start with a letter or number'
            },
            {
                validationMethod: formValidationMethods.containsLettersNumbersOrSpecialCharacters,
                errorMessage:
                    'Username must contain only letter, numbers, periods, hyphens, and underscores',
                validationLabel:
                    'Contains only letters, numbers, and the following allowed special characters: @ _ . -',
                ariaLabel:
                    'Must contain only letters, numbers, and the following allowed special characters: at sign, underscore, period, and hyphen'
            }
        ]
    };

    /**
     * @type { import('@pattern-library/base/dist/js/hooks/useFormValidation').FormValidationSchema}
     */

    const { hasError, onSubmit, onChange } = useFormValidation({ schema });

    return (
        <form
            action={formAction}
            method="post"
            onSubmit={onSubmit}
            onChange={onChange}
            noValidate
            autoComplete="off"
        >
            <div dangerouslySetInnerHTML={{ __html: antiForgeryToken }} />
            <UsernameLiveValidation
                isRequired
                criteria={schema.Username}
                hasError={hasError(usernameInputName)}
                errorMessage="Username does not meet all requirements"
                {...usernameInputProps}
            />

            <ButtonGroup alignment="center" className="asc-mt-4 asc-mb-0">
                <Button type="submit" className="asc-mtb-0" {...buttonProps} />
            </ButtonGroup>
        </form>
    );
}

UpdateUsernameForm.propTypes = propTypes;
export default UpdateUsernameForm;
